/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Session from '@/Session';
import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';
import GetAllAWPackageStatuses from '@/services/GetAllAWPackageStatuses';

import AWPackagePrintPage from '../pages/AWPackagePrintPage';
import GetAWPackage from '../services/GetAWPackage';
import ErrorView from '../../common/views/ErrorView/ErrorView';

export default async function ShowAWPackagePrintPage(awPackageId, activeSectionId, editMode) {
    NProgress.start();

    try {
        if (userHasRole('EPC') || userHasRole('Admin')) {
            NavUtils.navigate(`aw-package/${awPackageId}/print`);
        } else {
            showErrorView();
            return;
        }

        const [awPackage, awStatuses] = await Promise.all([
            GetAWPackage(awPackageId),
            GetAllAWPackageStatuses()
        ]);

        if (!awPackage?.id) {
            throw new Error('Not Found');
        }
        const isAssignedEPC = Session.user.id === awPackage?.epcId;
        Scaffold.getRegion('content').show(
            new AWPackagePrintPage({
                activeSectionId,
                awPackageId,
                isAssignedEPC,
                model: new Backbone.Model({
                    awPackage,
                    awStatuses
                })
            })
        );
    } catch (err) {
        Scaffold.getRegion('content').show(
            new ErrorView({
              model: new Backbone.Model({
                errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
                errorDetails: 'Something went wrong while loading the Print AW Package page.'
              })
            })
          );
    } finally {
        NProgress.done();
    }
}

function showErrorView(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
          errorDetails: 'Your account may not have permission to view the Print AW Package page.'
        })
      })
    );
}